import React from 'react';
import useWindowDimensions from "../../../helpers/Hooks/useWindowDimensions";
import Footer from "../../Footer";
import { getlanguagelist } from "../../../helpers/changelanguage";

const Container = ({ children }) => {
    const { height, width } = useWindowDimensions();
    const login_page_height = {
        height : height,
        width : width
    };
    let languagelist = getlanguagelist();
    return(
        /* style={login_page_height} */
        <div style={login_page_height}>
            <div className="container login-container">
                <div className="row">
                { children }
                </div>
               {/*  <Footer /> */}
            </div>
            <div className="clr25"></div>
            <Footer  language={languagelist}/>
        </div>
       
        
    )
};

export default Container;